import React, { type HTMLAttributes } from 'react';

import {
  Container,
  ImageGrid,
  Text,
} from '@uncinc/uncinc-react-kitchen-sink';
import { DynamicMediaItem } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import type { AspectRatio } from '@uncinc/react-drupal-core/dist/Components/DynamicMediaItem';

import type { ParagraphTextImageGrid as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphTextImageGridProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphTextImageGrid: React.FC<ParagraphTextImageGridProps> = ({ id, entity }) => {
  const paragraphTextImageGrid = entity.toJS();

  const title = paragraphTextImageGrid.field_title[0]?.value;
  const body = paragraphTextImageGrid.field_body[0]?.processed || '';
  const media = paragraphTextImageGrid.field_media_items;

  const imageGridItems = media.map((mediaItem, i) => {
    const caption = mediaItem.entity.field_caption[0]?.value;

    let aspectRatio: AspectRatio = '4_3';
    if (
      (media.length === 3 && i === 0) ||
      (media.length > 4 && i === 2)
    ) {
      aspectRatio = '3_1';
    }

    return (
      <>
        <DynamicMediaItem
          media={mediaItem}
          imageAspectRatio={aspectRatio}
        />

        {caption && (
          <span className="ParagraphTextImageGrid__caption">{caption}</span>
        )}
      </>
    );
  });

  return (
    <div id={id} className="Paragraph ParagraphTextImageGrid">
      <Container>
        <div className="row">
          <div className="ParagraphTextImageGrid__body col-12 col-lg-8 offset-lg-2">
            <Text
              title={title}
              text={body}
            />
          </div>

          <div className="col-12">
            <ImageGrid
              items={imageGridItems}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphTextImageGrid;
